import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'company-broker-status',
  templateUrl: './company-broker-status.component.html',
  styleUrls: ['./company-broker-status.component.css']
})
export class CompanyBrokerStatusComponent implements OnInit {

  constructor(private _router: Router) { }

  ngOnInit(): void {
  }

  onBackToList() {
    this._router.navigate(['/acordmessages']);
  }

}
